import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentAdminStatus } from "../Auth/auth";

export default function AdminCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function finishLogin() {
      const result = await getCurrentAdminStatus();

      if (result.authenticated && result.isAdmin) {
        navigate("/admin", { replace: true });
      } else {
        navigate("/admin/login", { replace: true });
      }
    }

    finishLogin();
  }, [navigate]);

  return <div className="p-8">Signing you in...</div>;
}